// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EmployeeNameResponse } from './employee-name-response';

// @ts-ignore
import { ProviderResponse } from './provider-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodLastEncounterResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodLastEncounterResponse extends GandalfModelBase {

	@GandalfProperty({ designType: EmployeeNameResponse })
	employee!: EmployeeNameResponse | null;

	@GandalfProperty({ designType: Date })
	encounterDate!: Date;

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfProperty({ designType: ProviderResponse })
	provider!: ProviderResponse | null;

	@GandalfProperty({ designType: String })
	templateName!: string | null;

}
